export const ITEM_STATUS = {
  FULFILLED: 'fulfilled',
  UNFULFILLED: 'unfulfilled'
}
